var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trck-content flood-right"},[_c('SewerPumpStations',{key:_vm.sewerKey,staticClass:"info-box"}),_c('StormPumpStations',{key:_vm.stormKey,staticClass:"info-box"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }